import { ICoordinatesModel } from './coordinates.model';
import { IParkingLotItem } from './parking-lots.model';

export interface IGatePayload {
  type: GateTypeEnum;
  parkingLotId: string;
  code: string;
  status: GateStatusEnum;
  cameraIP: string;
  coordinates: ICoordinatesModel[];
}

export interface IGateItem {
  id: string;
  type: GateTypeEnum;
  parkingLotId: string;
  code: string;
  status: GateStatusEnum;
  cameraIP: string;
  latitude?: number;
  longitude?: number;
  parkingLot: IParkingLotItem;
}

export interface IGateParams {
  id?: string;
  includes?: GateIncludesEnum;
  sortOrder?: string;
  orderBy?: string;
  pageIndex?: number;
  pageSize?: number;
  code?: string;
}

export enum GateIncludesEnum {
  None = 'None',
  ParkingLot = 'ParkingLot',
}

export enum GateTypeEnum {
  Entry = 'ENTRY',
  Exit = 'EXIT',
}

export const IGateTypeLabel: Record<GateTypeEnum, string> = {
  [GateTypeEnum.Entry]: 'Вход',
  [GateTypeEnum.Exit]: 'Выход',
};

export enum GateStatusEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Error = 'ERROR',
}

export const IGateStatusLabel: Record<GateStatusEnum, string> = {
  [GateStatusEnum.Open]: 'Открыт',
  [GateStatusEnum.Closed]: 'Закрыт',
  [GateStatusEnum.Error]: 'Тех работы',
};
